ui-textarea {
  display: block;

  .textarea {
    resize: inherit;

    &__label {
      display: block;
      max-width: 100%;
      margin-top: -5px;
      margin-bottom: 5px;
      font-weight: 400;
      color: $ui-dark;

      > .required {
        margin-left: 1px;
      }
    }

    &__hint {
      font-size: 12px;
      line-height: 18px;
    }

    &__lengthCounterMessage {
      text-align: end;
    }

    &--error {
      .textarea {
        &__label {
          color: $ui-red;
        }

        &__message {
          color: $ui-red;
        }
      }

      textarea {
        color: $ui-red;
        border-color: $ui-red;
      }
    }

    &--success {
      .textarea {
        &__label {
          color: $ui-green;
        }

        &__message {
          color: $ui-green;
        }
      }

      textarea {
        color: $ui-green;
        border-color: $ui-green;
      }
    }

    &--disabled {
      textarea {
        border-color: $ui-grey-plus-1;
      }

      .textarea {
        &__label {
          color: $ui-grey-plus-1;
        }
      }
    }
  }

  textarea {
    font-family: var(--skin-font-family-primary, $font-family-sans-serif);
    font-weight: $input-font-weight;
    font-size: 16px;
    line-height: 24px;
    width: 100%;
    /* stylelint-disable-next-line plugin/no-unsupported-browser-features */
    resize: inherit;
    color: var(--skin-color-text, $ui-dark);
    background-color: var(--skin-color-white, $ui-white);
    // Reset unusual Firefox-on-Android default style; see https://github.com/necolas/normalize.css/issues/214
    background-image: none;
    border: 1px solid $input-border-color;
    transition: border-color 0.1s linear;
    padding: 12px 14px;
    box-sizing: border-box;
    border-radius: 4px;

    &:focus {
      outline: none;
      border-color: var(--skin-color-primary, $ui-blue);
    }

    @include placeholder();
  }
}
